// src/redux/reducer.js

import { SET_CAR_TYPE, SET_SELECTED_PACKAGE, SET_SERVICE_PACKAGE_STATE } from './constants';

const INITIAL_STATE: any = {
  selectedCar: {
    vehicleCode: '',
    vehicleName: '',
    transmission: '',
    couponServices: [],
    servicePackage: [],
  },
  selectedPackage: {
    dayOfService: null,
    categories: null,
    typeOfService: null,
    vehicleModel: null,
    yearRange: null,
    yearOfService: null,
    price: {
      code: '',
      name: '',
      value: 0,
      formattedValue: '',
      strikeThroughPrice: null,
    },
  },
  isShowBaseModel: true,
};

const servicePackageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CAR_TYPE:
      return {
        ...state,
        selectedCar: action.payload,
      };
    case SET_SELECTED_PACKAGE:
      return {
        ...state,
        selectedPackage: action.payload,
      };
    case SET_SERVICE_PACKAGE_STATE:
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    default:
      return state;
  }
};

export default servicePackageReducer;
